<script>
	export let CurrGame;
	// for user output
	export let UserU = [' ',' ',' ',' ',' ',' ',' ',' ',' ',' '];
	export let UserR = [' ',' ',' ',' ',' ',' ',' ',' ',' ',' '];
	export let UserL = [' ',' ',' ',' ',' ',' ',' ',' ',' ',' '];
	export let UserD = [' ',' ',' ',' ',' ',' ',' ',' ',' ',' '];
	
	
	let Name = CurrGame.Name;
	//add console prompts
	let Description = '>' + CurrGame.Description.replaceAll('&','<br/>&gt;');
	export let COUT = '';
	let Uin_txt = '';
	let Lin_txt = '';
	let Rin_txt = '';
	let Din_txt = '';
	let Uout_txt = '';
	let Lout_txt = '';
	let Rout_txt = '';
	let Dout_txt = '';
	let DBGinU = [];
	let DBGinD = [];
	let DBGinL = [];
	let DBGinR = [];
	let DBGoutU = [];
	let DBGoutD = [];
	let DBGoutL = [];
	let DBGoutR = [];
	//we cut the array in half for displaying it
	//let DBGin = CurrGame.DBGinU.split(',');
	//let DBGout = CurrGame.DBGoutD.split(',');
	//let halfWayIndex = Math.floor(DBGin.length / 2);
	
	
	//inports
	if(CurrGame.InPort.search('U') >= 0)
	{
	    Uin_txt = 'U.IN';  
	    DBGinU = CurrGame.DBGinU.split(',');
	}
	if(CurrGame.InPort.search('R') >= 0)
	{
	    Rin_txt = 'R.IN';  
	    DBGinR = CurrGame.DBGinR.split(',');
	}
	if(CurrGame.InPort.search('L') >= 0)
	{
	    Lin_txt = 'L.IN';  
	    DBGinL = CurrGame.DBGinL.split(',');
	}
	if(CurrGame.InPort.search('D') >= 0)
	{
	    Din_txt = 'D.IN';  
	    DBGinD = CurrGame.DBGinD.split(',');
	}
	//outports
	if(CurrGame.OutPort.search('U') >= 0)
	{
	    Uout_txt = 'U.OUT';  
	    DBGoutU = CurrGame.DBGoutU.split(',');
	}
	if(CurrGame.OutPort.search('R') >= 0)
	{
	    Rout_txt = 'R.OUT';  
	    DBGoutR = CurrGame.DBGoutR.split(',');
	}
	if(CurrGame.OutPort.search('L') >= 0)
	{
	    Lout_txt = 'L.OUT';  
	    DBGoutL = CurrGame.DBGoutL.split(',');
	}
	if(CurrGame.OutPort.search('D') >= 0)
	{
	    Dout_txt = 'D.OUT';  
	    DBGoutD = CurrGame.DBGoutD.split(',');
	}
	//convenience half the size
	let DBGsizehalf = Math.floor(CurrGame.DBGsize/2);
	
	

	function GetDBGIn(portc)
	{
	    if(portc=='U')
	        return CurrGame.DBGinU.split(',');
	    
	    if(portc=='R')
	        return CurrGame.DBGinR.split(',');
	    
	    if(portc=='D')
	        return CurrGame.DBGinD.split(',');
	    
	    if(portc=='L')
	        return CurrGame.DBGinL.split(',');
	    
	}
	function GetDBGOut(portc)
	{
	    if(portc=='U')
	        return CurrGame.DBGoutU.split(',');
	    
	    if(portc=='R')
	        return CurrGame.DBGoutR.split(',');
	    
	    if(portc=='D')
	        return CurrGame.DBGoutD.split(',');
	    
	    if(portc=='L')
	        return CurrGame.DBGoutL.split(',');
	    
	}
	function GetUserOut(portc)
	{
	    if(portc=='U')
	        return UserU;
	    
	    if(portc=='R')
	        return UserR
	    
	    if(portc=='D')
	        return UserD;
	    
	    if(portc=='L')
	        return UserL;
	}
</script>
<style>
	#Proball{
		font-size:16px;
		width:450px;
		margin:auto auto;
		text-align: center;
	}
	#console{
		border: 1px solid #fff;
		height:100px;
		width:400px;
		text-align:left;
		margin-top:5px;
		margin-bottom:5px;
		background-color:#005522;
		color:#002200;
		font-family: monospace; 
	}
	
	.intests{
		border: 1px solid #fff;
	}
	.intests td{
		border-left: 1px solid #fff;
		border-right: 1px solid #fff;
		width:40px;
		margin-left:10px;
		margin-right:10px;
	}
	.out{
		color:#00FF00;
		width:20px;
	}

	#tests{
		padding-bottom:-5px;
		margin-bottom:-5px;
	}
</style>
<div id="Proball">
	<h3>- {Name} -</h3>
	<table id="console" align="center">
		<tr><td valign="top">{@html Description}<br/>{@html COUT}</td></tr>
	</table>
	
	<table align="center" cellspacing="10" id="tests">
		<tr>
		    {#each CurrGame.InPort as port}
                {#if port=='U'}<td>{Uin_txt}</td>{/if}
                {#if port=='D'}<td>{Din_txt}</td>{/if}
                {#if port=='L'}<td>{Lin_txt}</td>{/if}
                {#if port=='R'}<td>{Rin_txt}</td>{/if}
			{/each}
			
			{#each CurrGame.OutPort as port}
                {#if port=='U'}<td>{Uout_txt}</td>{/if}
                {#if port=='D'}<td>{Dout_txt}</td>{/if}
                {#if port=='L'}<td>{Lout_txt}</td>{/if}
                {#if port=='R'}<td>{Rout_txt}</td>{/if}
			{/each}
			
			<!-- split results for space -->
			<td style="width:30px;"></td>
			
			{#each CurrGame.InPort as port}
                {#if port=='U'}<td>{Uin_txt}</td>{/if}
                {#if port=='D'}<td>{Din_txt}</td>{/if}
                {#if port=='L'}<td>{Lin_txt}</td>{/if}
                {#if port=='R'}<td>{Rin_txt}</td>{/if}
			{/each}
			
			{#each CurrGame.OutPort as port}
                {#if port=='U'}<td>{Uout_txt}</td>{/if}
                {#if port=='D'}<td>{Dout_txt}</td>{/if}
                {#if port=='L'}<td>{Lout_txt}</td>{/if}
                {#if port=='R'}<td>{Rout_txt}</td>{/if}
			{/each}
		</tr>
		<tr>
		        
        {#each CurrGame.InPort as port}
            <td>
                <table class="intests" cellspacing="0">
                    {#each GetDBGIn(port).slice(0, DBGsizehalf) as num}
                    <tr><td>{num}</td></tr>
                    {/each}
                </table>
            </td>
        {/each}
		
        {#each CurrGame.OutPort as port}
            <td>
                <table class="intests" cellspacing="0">
                    {#each GetDBGOut(port).slice(0, DBGsizehalf) as num, i}
                    <tr><td>{num}</td>
                        <!--<td class="out">{@html GetUserOut(port)[i]}</td>-->
                        <td class="out">
                            {#if port=='U'}{@html UserU[i]}{/if}
                            {#if port=='D'}{@html UserD[i]}{/if}
                            {#if port=='L'}{@html UserL[i]}{/if}
                            {#if port=='R'}{@html UserR[i]}{/if}
                        </td>
                    </tr>
                    {/each}
                </table>
            </td>
        {/each}

        <!--2nd half-->
        <!-- split results for space -->
		<td style="width:30px;"></td>
        {#each CurrGame.InPort as port}
            <td>
                <table class="intests" cellspacing="0">
                    {#each GetDBGIn(port).slice(DBGsizehalf) as num}
                    <tr><td>{num}</td></tr>
                    {/each}
                </table>
            </td>
        {/each}
		
        {#each CurrGame.OutPort as port}
            <td>
                <table class="intests" cellspacing="0">
                    {#each GetDBGOut(port).slice(DBGsizehalf) as num, i}
                    <tr><td>{num}</td>
                        <!--<td class="out">{@html GetUserOut(port)[i]}</td>-->
                        <td class="out">
                            {#if port=='U'}{@html UserU[i + DBGsizehalf]}{/if}
                            {#if port=='D'}{@html UserD[i + DBGsizehalf]}{/if}
                            {#if port=='L'}{@html UserL[i + DBGsizehalf]}{/if}
                            {#if port=='R'}{@html UserR[i + DBGsizehalf]}{/if}
                        </td>
                    </tr>
                    {/each}
                </table>
            </td>
        {/each}
        
		</tr>
	</table>
	
</div>